<template>
  <a-form ref="formRef" layout="vertical" :model="formState">
    <RequiredField v-model:required="formState.required" />

    <a-form-item label="Texto del campo" name="label" required>
      <a-input v-model:value="formState.label" placeholder="Escribir texto del campo" />
      <p class="info">Escriba aquí su pregunta</p>
    </a-form-item>

    <a-form-item label="Instrucciones">
      <a-input v-model:value="formState.instruction" placeholder="Escribir instrucciones" />
      <p class="info">Añada una pequeña descripción debajo del campo de entrada</p>
    </a-form-item>

    <a-form-item class="label__range" label="Rango de horas">
      <a-switch v-model:checked="formState.is_range" size="small" />
      <p class="info">El usuario podrá escribir una hora inicial y una final</p>
    </a-form-item>
  </a-form>
</template>

<script setup lang="ts">
import { reactive, ref } from "vue";
import type { FormInstance } from "ant-design-vue";

import { ElementType, FormElementMap, FormStateElementMap } from "@/@types/entities/forms";

import RequiredField from "@/app/entities/components/drawers/forms/settings/fields/RequiredField.vue";

const props = defineProps<{
  input: FormElementMap[ElementType.Hour];
}>();

const formRef = ref<FormInstance | undefined>(undefined);

const formState: FormStateElementMap[ElementType.Hour] = reactive({
  label: props.input.label,
  instruction: props.input.instruction,
  required: props.input.required,
  is_range: props.input.is_range,
});

defineExpose({ formRef, formState });
</script>

<style scoped lang="sass">
p
  margin: 0

.ant-form-item-label
  padding: 0

.info
  color: $gray-7

:deep(.label__range .ant-form-item-label)
  padding: 0 !important
</style>
